import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  computed,
  effect,
  input,
  output,
  signal,
  viewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';

import { trapTabKey } from '../../utils/focus-trap.util';
import { ButtonComponent } from '../button/button.component';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-prompt-dialog',
  templateUrl: './prompt-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ModalComponent, ButtonComponent, FormsModule],
})
export class PromptDialogComponent {
  open = input.required<boolean>();
  title = input('');
  message = input('');
  label = input('Motivo');
  placeholder = input('');
  confirmLabel = input('Confirmar');
  cancelLabel = input('Cancelar');
  submitting = input(false);
  allowEmpty = input(false);
  maxLength = input<number | null>(null);
  initialValue = input('');

  confirmed = output<string>();
  cancelled = output<void>();

  protected readonly text = signal('');
  protected readonly canConfirm = computed(() => this.allowEmpty() || this.text().trim().length > 0);

  private readonly field = viewChild<ElementRef<HTMLTextAreaElement>>('field');
  private readonly dialogRoot = viewChild<ElementRef<HTMLElement>>('dialogRoot');
  private previousFocus: HTMLElement | null = null;

  private readonly manageFocus = effect(() => {
    if (this.open()) {
      this.previousFocus = document.activeElement as HTMLElement | null;
      this.text.set(this.initialValue());
      setTimeout(() => this.field()?.nativeElement.focus());
    } else {
      this.previousFocus?.focus();
      this.previousFocus = null;
    }
  });

  @HostListener('document:keydown.escape')
  protected onEscape(): void {
    if (this.open()) this.cancelled.emit();
  }

  @HostListener('document:keydown', ['$event'])
  protected onKeydown(event: KeyboardEvent): void {
    const root = this.dialogRoot()?.nativeElement;
    if (this.open() && root) trapTabKey(event, root);
  }

  protected confirm(): void {
    if (!this.canConfirm() || this.submitting()) return;
    this.confirmed.emit(this.text().trim());
  }
}
